import { needAddStr, notNeedSaveDraft } from './enum'

const validIsTeamMember = () => {
  const mine = window.$mine || {}
  const { teamLeaderBalance } = mine
  if (teamLeaderBalance) return true
  return false
}

/**
 * @description: 处理团队下单时的服务订单跳转
 * @param {type} type
 */
const dealServiceJumpOrder = (type) => {
  const list = {
    'ASO_SERVICE': '/wap/order?type=aso',
    'API_SERVICES': 0,
    'KEYWORD_RANKING_ACQUISITION': '/wap/order?type=keyword',
  }
  const url = list[type]
  if (url === 0) {
    return
  }
  location.assign(url || '/wap/order')
}

// needAddStr  需要添加字符串的服务
// notNeedSaveDraft  不需要保存的服务
/**
 *
 * @param {ServiceType} type
 * @param {是否需要处理不保存的后续} needDealNotSave
 * @param {需要的充值} needMoney
 * @returns
 */
const dealServiceSaveDraft = async(type, needDealNotSave, option) => {
  const { saveDraftbeforePro } = option.func
  if (!notNeedSaveDraft.includes(type)) {
    console.log(saveDraftbeforePro)
    saveDraftbeforePro && await saveDraftbeforePro()
  }
  if (needDealNotSave) {
    const { needMoney } = option
    let str = ''
    let needReturn = false
    if (needAddStr.includes(type)) {
      str = `&serviceType=${type}`
    } else if (type === 'ASO_SERVICE') {
      //* Aso service直接open页面
      window.open(`${window.location.origin}/my/money?need=${needMoney}`, '_blank')
      needReturn = true
    }
    return {
      needReturn,
      str
    }
  }
}

export {
  validIsTeamMember,
  dealServiceJumpOrder,
  dealServiceSaveDraft
}
